<template>
  <div class="xcard">
    <v-btn small class="mx-4" @click="$router.back()" color="info" rounded outlined>
      <v-icon>mdi-arrow-left-bold</v-icon> Volver Atras</v-btn
    >
    <template>
      <v-data-table :headers="headers" :items="desserts" :loading="loading" sort-by="calories" class="elevation-1">
        <template v-slot:top>
          <v-toolbar flat>
            <v-toolbar-title> Emision por paquetes </v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-spacer></v-spacer>
            <v-btn class="green darken-2 white--text" @click="editItem()">
              <v-icon small class="mr-2">
                mdi-pencil
              </v-icon>
              Agregar
            </v-btn>
          </v-toolbar>
        </template>
        <template v-slot:[`item.opciones`]="{ item }">
          <v-icon small class="mr-2" @click="editItem(item)">
            mdi-pencil
          </v-icon>
        </template>
      </v-data-table>
    </template>

    <EventosReg ref="eventosreg" v-on:newregevento="newregevento" />
  </div>
</template>

<script>
  import EventosReg from '@/views/recibos/emisionpaq/recepcionpaquete.vue';
  import xaxios from '@/xaxios';
  export default {
    data: () => ({
      dialog: false,
      dialogDelete: false,
      loading: false,
      headers: [
        { text: 'Nombre', value: 'nombre' },
        { text: 'Municipio', value: 'municipio' },
        { text: 'Telefono', value: 'telefono' },
        { text: 'Direccion', value: 'direccion' },
        { text: 'Codigo Sucursal', value: 'codigoSucursal' },
        { text: 'Opciones', value: 'opciones', sortable: false },
      ],
      desserts: [],
      editedIndex: -1,
      editedItem: {
        name: '',
        calories: 0,
        fat: 0,
        carbs: 0,
        protein: 0,
      },
      defaultItem: {
        name: '',
        calories: 0,
        fat: 0,
        carbs: 0,
        protein: 0,
      },
    }),

    components: { EventosReg },

    computed: {
      formTitle() {
        return this.editedIndex === -1 ? 'New Item' : 'Edit Item';
      },
    },

    watch: {
      dialog(val) {
        val || this.close();
      },
      dialogDelete(val) {
        val || this.closeDelete();
      },
    },

    created() {
      this.initialize();
    },

    methods: {
      initialize() {
        let vue = this;
        vue.loading = true;
        var config = {
          method: 'get',
          url: `${process.env.VUE_APP_FACT_REST}/facturacion/eventosignificativo`,
          headers: {},
        };

        xaxios.request(config)
          .then(function(response) {
            let data = response.data;
            window.console.log('eventos:', data);
            vue.desserts = data;
            vue.loading = false;
          })
          .catch(function(error) {
            window.console.log(error);
            vue.loading = false;
          });
      },

      newregevento(item) {
        let e = this.desserts.find((x) => x.id == item.id);
        if (e) {
          e.razon_social = item.razon_social;
          e.numero_documento = item.numero_documento;
          e.numero_documento = item.numero_documento;
          e.complemento = item.complemento;
          e.tipo_documento_id = item.tipo_documento_id;
        }
      },

      editItem(item) {
        this.editedIndex = this.desserts.indexOf(item);
        this.editedItem = Object.assign({}, item);
        //this.dialog = true;
        this.$refs.eventosreg.openmodal(item);
      },

      deleteItem(item) {
        this.editedIndex = this.desserts.indexOf(item);
        this.editedItem = Object.assign({}, item);
        //this.dialogDelete = true;
        this.$refs.unidadesdel.openmodal();
      },

      deleteItemConfirm() {
        this.desserts.splice(this.editedIndex, 1);
        this.closeDelete();
      },

      close() {
        this.dialog = false;
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem);
          this.editedIndex = -1;
        });
      },

      closeDelete() {
        this.dialogDelete = false;
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem);
          this.editedIndex = -1;
        });
      },
    },
  };
</script>
